"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var braintree_web_1 = require("braintree-web");
var graphql_tag_1 = require("graphql-tag");
var ApolloClient_1 = require("src/ApolloClient");
var ErrorBoundary_1 = require("src/ErrorBoundary");
var BookshelfPage_1 = require("src/bookstore/Bookshelf/BookshelfPage");
var UserCart_1 = require("src/bookstore/UserCart/UserCart");
var FinalizeCartGQL_1 = require("./FinalizeCartGQL");
var PaymentForm_1 = require("./PaymentForm");
var GetBraintreeTokenGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\nmutation GetBraintreeToken {\n  getBraintreeToken\n}\n"], ["\nmutation GetBraintreeToken {\n  getBraintreeToken\n}\n"])));
var ConnectedPaymentForm = /** @class */ (function (_super) {
    __extends(ConnectedPaymentForm, _super);
    function ConnectedPaymentForm(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            var cartData = _this.props.userCart.cartData;
            if (cartData === null) {
                return null;
            }
            return (React.createElement(PaymentForm_1.default, { onSubmit: _this.onSubmit, onSubmitWithoutNonce: _this.onSubmitWithoutNonce, errors: _this.state.errors, disabled: _this.state.disabled, cart: cartData }));
        };
        /**
         * Prvent form from submitting as html form, and send to event handler.
         * Post credit cart info to Braintrees credit cart endpoint.
         */
        _this.onSubmit = function (cardData) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.state.disabled) {
                    return [2 /*return*/];
                }
                this.setState({ disabled: true });
                this.braintreeClient.request({
                    endpoint: 'payment_methods/credit_cards',
                    method: 'post',
                    data: { creditCard: cardData }
                }, this.handleBraintreeResponse);
                return [2 /*return*/];
            });
        }); };
        /**
         * Submit without nonce from braintree, used when cart total is 0
         */
        _this.onSubmitWithoutNonce = function (_e) {
            if (_this.state.disabled) {
                return;
            }
            _this.setState({ disabled: true });
            _this.finalizeCart();
        };
        /**
         * Display errors, or extract nonce from braintree response.
         * Use nonce to finalize cart
         */
        _this.handleBraintreeResponse = function (requestError, response) {
            if (requestError) {
                _this.props.displayMessage(requestError.message, 'error');
                _this.setState({ errors: exports.braintreeErrorToErrorMap(requestError), disabled: false });
                return;
            }
            _this.setState({ errors: {} });
            var nonce = response &&
                response.creditCards &&
                response.creditCards[0] &&
                response.creditCards[0].nonce;
            if (nonce === undefined) {
                return _this.props.displayMessage('Response didn\'t include transaction information', 'error');
            }
            console.log('Nonce recieved from Braintree, finalizing cart');
            _this.finalizeCart(nonce);
        };
        /**
         * Post to the finalize cart mutation. Handle finalized cart response, or display error.
         */
        _this.finalizeCart = function (paymentNonce) {
            if (paymentNonce === void 0) { paymentNonce = null; }
            return __awaiter(_this, void 0, void 0, function () {
                var e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, ApolloClient_1.apolloClient.mutate({
                                    mutation: FinalizeCartGQL_1.FinalizeCartGQL,
                                    variables: { finalizeCartArguments: { paymentNonce: paymentNonce } },
                                    update: this.updateLibraryPageCache
                                })];
                        case 1:
                            _a.sent();
                            this.props.userCart.refetch();
                            this.props.displayMessage('Transaction Complete! The book is now in your library.', 'success');
                            this.props.onPaymentComplete();
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            this.setState({ disabled: false });
                            this.props.displayMessage(e_1.message, 'error');
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        _this.updateLibraryPageCache = function (cache, result) {
            if (!result.data) {
                _this.props.displayMessage('Empty response from finalize cart mutation.', 'error');
                return;
            }
            var queryArgs = { query: BookshelfPage_1.SearchBookshelfGQL, variables: { isOnShelf: true } };
            var oldResults = cache.readQuery(queryArgs) || { searchBooks: [] };
            var searchBooks = result.data.finalizeCart ?
                oldResults.searchBooks.concat(result.data.finalizeCart) :
                oldResults.searchBooks;
            cache.writeQuery(__assign(__assign({}, queryArgs), { data: {
                    searchBooks: oldResults.searchBooks.concat(searchBooks)
                } }));
        };
        _this.state = {};
        return _this;
    }
    ConnectedPaymentForm.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var result, clientTokenResponse, brainTreeToken, _a, e_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 5, , 6]);
                        return [4 /*yield*/, ApolloClient_1.apolloClient.mutate({ mutation: GetBraintreeTokenGQL })];
                    case 1:
                        result = _b.sent();
                        if (!result.data) {
                            this.props.displayMessage('Response data empty when fetching braintree token.', 'error');
                            return [2 /*return*/];
                        }
                        clientTokenResponse = result.data;
                        brainTreeToken = clientTokenResponse.getBraintreeToken;
                        if (!brainTreeToken) return [3 /*break*/, 3];
                        _a = this;
                        return [4 /*yield*/, braintree_web_1.client.create({ authorization: brainTreeToken })];
                    case 2:
                        _a.braintreeClient = _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.props.displayMessage('getBraintreeToken mutation did not return a token', 'error');
                        _b.label = 4;
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_2 = _b.sent();
                        this.props.displayMessage(e_2.message, 'error');
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return ConnectedPaymentForm;
}(React.Component));
/**
 * Extracts errors from braintree response
 */
exports.braintreeErrorToErrorMap = function (requestError) {
    var allFieldErrors = requestError.details &&
        requestError.details.originalError &&
        requestError.details.originalError.fieldErrors;
    if (!allFieldErrors) {
        return {};
    }
    // create error map from response
    return allFieldErrors.reduce(function (acc, _a) {
        var fieldErrors = _a.fieldErrors;
        // pick out errors from each field set child
        var combindedErrors = fieldErrors.reduce(function (accInner, _a) {
            var _b;
            var field = _a.field, message = _a.message;
            return Object.assign({}, accInner, (_b = {}, _b[field] = message, _b));
        }, {});
        // combine into top level error map
        return Object.assign({}, acc, combindedErrors);
    }, {});
};
exports.default = ErrorBoundary_1.withDisplayMessage(UserCart_1.withUserCart(ConnectedPaymentForm));
var templateObject_1;
